export const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    // Check if the token has the correct structure (header.payload.signature)
    const parts = token.split(".");
    if (parts.length !== 3) {
      console.error("Invalid token format");
      return false;
    }

    // Decode the payload
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const decodedToken = JSON.parse(atob(base64));
    const currentTime = Date.now() / 1000;
    // console.log("Decoded token:", decodedToken);

    // Mock signature validation
    const mockSignature = "mockSignature";
    if (parts[2] !== mockSignature) {
      console.error("Invalid token signature");
      return false;
    }

    return decodedToken.exp > currentTime; // Check expiration
  } catch (err) {
    console.error("Error decoding token:", err);
    return false;
  }
};
